/**
 * Text Generation API
 *
 * API client for the text-generation model registry (ADR-019 Phase 3).
 * Endpoints: /api/v1/text-generation/*
 */

import { apiClient } from '../api-client';

export interface AvailableModel {
  id: string;
  name: string;
  description: string;
  capabilities: string[];
  provider?: string;
}

export async function getAvailableModels(): Promise<AvailableModel[]> {
  const response = await apiClient.get<{ models: AvailableModel[] }>(
    '/api/v1/text-generation/models'
  );
  return response.data.models;
}
